import * as yup from 'yup';

export const schema = yup.object().shape({
  date: yup.string().nullable().required("Le champ 'date' est obligatoire."),
});
